import * as yup from "yup";

import { UserFormFields } from "@/types/types";

// t('error_letters_only')
function basicString(errorMsg: string) {
  return yup
    .string()
    .required()
    .matches(/^([^0-9]*)$/, errorMsg);
}

export function first_name(errorMsg: string) {
  return {
    first_name: basicString(errorMsg),
  };
}

export function last_name(errorMsg: string) {
  return {
    last_name: basicString(errorMsg),
  };
}

export function invitation_code(errorMsg: string) {
  return {
    invitation_code: basicString(errorMsg),
  };
}

// t('error_phone')
export function mobile(errorMsg: string) {
  return {
    mobile: yup.string().length(8, errorMsg),
  };
}

// t("error_email_only")
export function email(errorMsg: string) {
  return {
    email: yup
      .string()
      .matches(
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        errorMsg
      )
      .optional(),
  };
}

// t("error_agree")
export function gdpAgree(errorMsg: string) {
  return {
    gdpAgree: yup.boolean().required().oneOf([true], errorMsg),
  };
}

export function createUserFormValidationSchema(errorMsgs: {
  first_name: string;
  last_name: string;
  email: string;
  mobile: string;
}): yup.Schema<UserFormFields> {
  return yup.object().shape({
    ...first_name(errorMsgs.first_name),
    ...last_name(errorMsgs.last_name),
    ...email(errorMsgs.email),
    ...mobile(errorMsgs.mobile),
  });
}

// Pass in whatever fields you want to validate (fieldname must = schema key)
// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export default function setSchema(schema: {}) {
  return yup.object().shape(schema);
}
